import { render, staticRenderFns } from "./Hdglmx.vue?vue&type=template&id=bf772abe&scoped=true"
import script from "./Hdglmx.vue?vue&type=script&lang=js"
export * from "./Hdglmx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf772abe",
  null
  
)

export default component.exports